<template>
  <v-container id="subscriptionForm" class="subscriptionFormContainer px-10">
    <v-layout text-center wrap>
      <v-flex xs12 class="pt-10 text-left">
        <h1>Corporate Membership Enrollment Form</h1>
        <v-divider class="mt-4 mb-8"></v-divider>
        <p>
          <b>Authoritative. Influential. Trusted.</b> – “If you’re not using one
          of The Outdoor Wires you are already trailing the competition.”
        </p>
        <p>
          <b>
            The Outdoor Wire Digital Network offers the fastest and most
            affordable vehicle to get your news to the industry and your
            customers
          </b>
          - With a single payment (*) you can distribute an entire year’s worth
          of information to our targeted readership which includes hundreds of
          media members at notable media outlets worldwide.
        </p>

        <v-divider class="mb-2"></v-divider>

        <v-row>
          <v-col cols="4">
            $1,500 – Single Wire
            <br />$2,900 – Four Wires <br />$5,500 – All Wires (@)
          </v-col>
          <v-col cols="4">
            $2,200 – Three Wires
            <br />$3,600 – Five Wires
          </v-col>
        </v-row>

        <v-divider class="mb-5 mt-1"></v-divider>

        <p>
          Please provide contact information and select the wires you wish to
          distribute to:
        </p>

        <v-form v-model="valid">
          <v-text-field
            v-model="fieldMap.name"
            :rules="rules"
            outlined
            label="Name"
            required
          ></v-text-field>

          <v-text-field
            v-model="fieldMap.title"
            :rules="rules"
            outlined
            label="Title"
            required
          ></v-text-field>

          <v-text-field
            v-model="fieldMap.company"
            :rules="rules"
            outlined
            label="Company"
            required
          ></v-text-field>

          <v-text-field
            v-model="fieldMap.email"
            :rules="emailRules"
            outlined
            label="Email Address"
            required
          ></v-text-field>

          <v-text-field
            v-model="fieldMap.phone"
            :rules="rules"
            outlined
            label="Phone"
            required
          ></v-text-field>

          <v-divider class="mb-6"></v-divider>

          <v-text-field
            v-model="fieldMap.address"
            :rules="rules"
            outlined
            label="Address"
            required
          ></v-text-field>

          <v-text-field
            v-model="fieldMap.address2"
            outlined
            label="Address2"
            required
          ></v-text-field>

          <v-row no-gutters>
            <v-col cols="6" class="pr-5">
              <v-text-field
                v-model="fieldMap.city"
                outlined
                label="City"
                :rules="rules"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="3" class="pr-5">
              <v-text-field
                v-model="fieldMap.state"
                outlined
                label="State"
                :rules="rules"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                v-model="fieldMap.zip"
                outlined
                label="Zip"
                :rules="rules"
                required
              ></v-text-field>
            </v-col>
          </v-row>

          <v-divider class="mb-6"></v-divider>

          <v-text-field
            v-model="fieldMap.editorialEmail"
            outlined
            label="Editorial Email"
            :rules="rules"
            required
          ></v-text-field>

          <v-text-field
            v-model="fieldMap.contactEmail"
            outlined
            label="Contact Email"
            :rules="rules"
            required
          ></v-text-field>

          <v-text-field
            v-model="fieldMap.accountsPayable"
            outlined
            label="Accounts Payable"
            required
          ></v-text-field>

          <v-divider class="mt-4 mb-6"></v-divider>

          <v-row>
            <v-col cols="1"></v-col>
            <v-col cols="10">
              <div class="ml-5">
                <v-btn @click="selectAll()" color="primary"
                  >Add All Newsletters</v-btn
                >
              </div>
            </v-col>
          </v-row>

          <div v-for="brand in brands" :key="brand.projectId">
            <v-row>
              <v-col cols="1">
                <div class="pl-4">
                  <v-checkbox v-model="brand.isSelected"></v-checkbox>
                </div>
              </v-col>
              <v-col cols="11">
                <div class="my-3 px-8">
                  <h2 class="mb-3">{{ brand.name }}</h2>
                  <div>
                    {{ brand.description }}
                    <div class="mt-2" v-if="brand.suffix">
                      <b>{{ brand.suffix }}</b>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
            <v-divider></v-divider>
          </div>

          <div class="mt-6">
            <p>
              (*) “Annual” is for the calendar year running 1 January - 31
              December. Subsequent annual invoices will be automatically
              generated in November/December for following year.
            </p>

            <p>
              (@) All Wire subscriptions will include posts that are appropriate
              for the individual wire (i.e. Ammunition press releases would not
              be included in the Birding Wire, which a flashlight release would
              be appropriate for all wires.)
            </p>

            <p>
              Subscription Order Acceptance. Each part of any order that you
              submit to The Outdoor Wire Digital Network constitutes an offer to
              purchase the services outlined above.
            </p>

            <p>
              The Outdoor Wire Digital Network reserves the right to deny any
              order for any reason.
            </p>

            <p>
              Your company agree to pay all fees or charges in accordance with
              the fees, charges and billing terms in effect at the time a fee or
              charge is due and payable.
            </p>

            <p>
              Your membership will be automatically renewed at the end of the
              calendar year unless The Outdoor Digital Network is notified by
              December 1st of the current membership year.
            </p>

            <p>
              <b>ALL INVOICES ARE DUE UPON RECEIPT, PLEASE PAY PROMPTLY.</b>
            </p>
          </div>

          <v-btn
            class="my-10"
            color="primary"
            :disabled="!valid || !hasSelectedBrands"
            @click="submit"
            >Submit</v-btn
          >
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import Vue from "vue";

export default {
  name: "SubscriptionForm",
  computed: {
    hasSelectedBrands() {
      return this.brands.find(brand => {
        return brand.isSelected;
      });
    },
    selectedBrand() {
      return `${this.$route.query.brand}`.toLowerCase();
    },
  },
  async created() {
    await this.getBrands();
    this.brands.forEach(brand => {
      if (brand.shortname === this.selectedBrand) {
        Vue.set(brand, "isSelected", true);
      }
      return brand;
    });
  },
  data() {
    return {
      brands: [],
      emailRules: [
        v => !!v || "Required field",
        v =>
          (!!v &&
            /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9-]+)*$/i.test(
              v
            )) ||
          "Invalid email address format",
      ],
      fieldMap: {
        accountsPayable: "",
        address: "",
        address2: "",
        city: "",
        company: "",
        contactEmail: "",
        editorialEmail: "",
        email: "",
        formName: "web",
        name: "",
        phone: "",
        state: "",
        title: "",
        zip: "",
      },
      rules: [v => !!v || "Required field"],
      valid: true,
    };
  },
  methods: {
    async getBrands() {
      const results = await axios({
        url: "/api/brands",
        method: "get",
      });
      const filteredBrands = results.data.filter(
        brand => ![37, 40].includes(brand.projectId)
      );
      this.brands = filteredBrands;
    },
    selectAll() {
      this.brands = this.brands.map(brand => {
        brand.isSelected = true;
        return brand;
      });
    },
    async submit() {
      const brands = this.brands
        .filter(brand => brand.isSelected)
        .map(brand => brand.name);

      await axios({
        url: "/api/signup",
        method: "post",
        data: {
          ...this.fieldMap,
          brands,
        },
      });

      this.$router.push({ name: "signupComplete" });
    },
  },
};
</script>
<style>
.v-input__slot {
  padding-bottom: 0 !important;
  margin-bottom: 0 !important;
}

.subscriptionFormContainer {
  max-width: 800px;
}
</style>
